<div class="main-component ">

    <aoe-header title="Suivre un évènement ou retrouver un résultat"
        [backgroundImage]="'/assets/img/header.jpg'"></aoe-header>

    @if (isLoading) {
    <aoe-loading-spinner>
        <p class="small">Chargement des évènements</p>
    </aoe-loading-spinner>
    } @else {
    <div class="content container">


        @if (nbEventAvailable === 0) {
        <p class="text-center m-4">Aucun évènement disponible pour le moment</p>
        } @else {
        @if (eventsInProgress.length) {
        <div class="liveEvent events">
            <h2 class="title">Evènements en cours</h2>
            <div class="eventCards d-flex flex-row justify-content-md-around flex-wrap justify-content-center">
                @for (event of eventsInProgress; track $index) {<aoe-event-card [event]="event"></aoe-event-card>}
            </div>
        </div>
        }

        @if (eventsSoon.length) {
        <div class="nextEvent events">
            <div class="title">
                <h2>Prochains évènements</h2>
            </div>

            <div class="eventCards d-flex flex-row justify-content-md-around flex-wrap justify-content-center">
                @for (event of eventsSoon; track $index) {<aoe-event-card [event]="event"></aoe-event-card>}
            </div>
        </div>
        }

        @if (eventsResults.length) {
        <div class="result events">
            <h2 class="title">Evènements terminés</h2>
            <div class="eventCards d-flex flex-row justify-content-md-around flex-wrap justify-content-center">
                @for (event of eventsResults; track $index) {<aoe-event-card [event]="event"></aoe-event-card>}
            </div>
        </div>
        }
        }


    </div>
    }
</div>